import { Text } from "preact-i18n";
import { Button } from "@mui/material";

import { stringify } from "qs";

const clientId = CLIENT_ID; // eslint-disable-line no-undef
const redirectUri = REDIRECT_URI; // eslint-disable-line no-undef

export function generateAuthFlowUrl(signup, emailAddress) {
  const state = Math.random().toString().substr(2, 8).toString();

  window.localStorage.setItem("oauth_state", state);
  const query = stringify({
    response_type: "code",
    client_id: clientId,
    // TODO Use proper redirect
    redirect_uri: redirectUri,
    scope: ["user:info:read", "mail:*"],
    state,
    signup: signup ? "true" : null,
    emailAddress,
  });

  // TODO Don't hardcode
  return `https://wasc.io/authorize?${query}`;
}

const LoginButton = ({ children, signup, onClick }) => (
  <Button
    className="flex-end"
    color="inherit"
    style={{
      backgroundColor: "white",
    }}
    variant="outlined"
    onClick={() => {
      onClick();
      window.location = generateAuthFlowUrl(signup);
    }}
  >
    <span>{children || <Text id="LoginButton" fall />}</span>
  </Button>
);

export default LoginButton;
